// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2yQnK","list":"PatternAutocomplete_list__12iwU"};